import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInvoiceDetails } from "../../../redux/actions";
import {
  Card,
  Label,
  Row,
  Col,
  NavbarBrand,
  Nav,
  Navbar,
  NavbarText,
  Table,
} from "reactstrap";
import Loader from "../../loader";
import defaultAvatar from "../../../assets/images/defaultImages/defaultAvatar.png";

export default function CommonInvoiceDetail({ id }) {
  const dispatch = useDispatch();

  const {
    loading = true,
    detail = {},
    error = false,
  } = useSelector((state) => state.InvoiceDetailReducer);

  const {
    actualInvoiceAmount = 0,
    agencyAddress = "",
    agencyLogo = "",
    companyName = "",
    couponDiscountPercentage = 0,
    customerName = "",
    invoiceExpiryDate = "",
    invoiceItems = [],
    invoiceNumber = "",
    paymentAmount = 0,
    taxPercentage = 0,
    agencyPhone = 0,
    locationCode = "",
  } = detail;

  const calculateTaxAmount = () => {
    let taxamount = (actualInvoiceAmount / 100) * taxPercentage;
    return taxamount;
  };

  const calculateCouponAmount = () => {
    let couponAmount = (actualInvoiceAmount / 100) * couponDiscountPercentage;
    return couponAmount;
  };

  //Mount
  useEffect(() => {
    dispatch(getInvoiceDetails(id));
  }, []);

  return (
    <>
      <div style={{ backgroundColor: "#fff", border: "10px solid #fff" }}>
        {loading ? (
          <Loader />
        ) : error ? (
          <div className="">
            <center>
              <h4>{detail}</h4>
            </center>
          </div>
        ) : (
          <div className="preview-invoice-model">
            <Navbar color="white">
              <NavbarBrand href="/">
                <img
                alt='logo'
                  src="https://payform.us/static/media/logo.0ced2d30.png"
                  className="logo mb-3 mt-3"
                />
              </NavbarBrand>
              <Nav className="me-auto" navbar></Nav>
              <NavbarText className="invoice-client-logo">
                <img
                alt="logo"
                  className="uploadImg"
                  src={agencyLogo || defaultAvatar}
                  // width={100}
                  // height={100}
                />
              </NavbarText>
            </Navbar>

            <section className="invoice-tem">
              <div className="top">
                <h4>Invoice from {companyName}</h4>

                <p>Invoice: #{invoiceNumber}</p>
              </div>
              <div>
                <Card body className="info-card">
                  <Row className="info">
                    <Col md="3">
                      <span>From</span>
                      <h5>{companyName || "-"}</h5>
                    </Col>
                    <Col md="3">
                      <span>Billed To</span>
                      <h5>{customerName || "-"}</h5>
                    </Col>
                    <Col md="3">
                      <span>Due Date</span>
                      <h5>{invoiceExpiryDate || "-"}</h5>
                    </Col>
                    <Col md="3">
                      <span>Amount Due</span>
                      <h5>${paymentAmount.toFixed(2)}</h5>
                    </Col>
                  </Row>
                  <Row className="info">
                    <Col md="3">
                      <span>Phone Number</span>
                      <h5>{agencyPhone || "-"}</h5>
                    </Col>

                    <Col md="3">
                      <span>Location Code</span>
                      <h5>{locationCode}</h5>
                    </Col>
                    <Col md="6">
                      <span>Address</span>
                      <h5>{agencyAddress || "-"}</h5>
                    </Col>
                  </Row>
                </Card>

                <Card body className="summary-card">
                  <h6>Summary</h6>
                  <hr className="m-0 mb-2" />
                  <Table bordered className="invoice-preview">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Quantity</th>
                        <th>Item Price</th>
                        <th className="text-end">Total Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoiceItems &&
                        JSON.parse(invoiceItems).map((data) => {
                          const {
                            itemDescription,
                            quantity,
                            individualAmount,
                          } = data;
                          return (
                            <tr>
                              <td>{itemDescription}</td>
                              <td>{quantity}</td>
                              <td>
                                ${parseFloat(individualAmount).toFixed(2)}
                              </td>
                              <td className="text-end">
                                $
                                {parseFloat(
                                  quantity * individualAmount
                                ).toFixed(2)}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>

                  <hr className="m-0 mb-2" />
                  <Row className="total-sec">
                    <Col md="12">
                      <div className="price-list">
                        <div className="list">
                          <Label for="" className="">
                            Sub Total
                          </Label>
                          <h6>${actualInvoiceAmount.toFixed(2)}</h6>
                        </div>
                        <div className="list">
                          <Label for="" className="">
                            Tax ({taxPercentage}%)
                          </Label>

                          <h6>${calculateTaxAmount().toFixed(2)}</h6>
                        </div>
                        <div className="list">
                          <Label for="" className="">
                            Discount ({couponDiscountPercentage}%)
                          </Label>
                          <h6>${calculateCouponAmount().toFixed(2)}</h6>
                        </div>
                        <div className="list bold">
                          <Label for="" className="">
                            Amount Due
                          </Label>

                          <h6>${paymentAmount.toFixed(2)}</h6>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </div>
            </section>
          </div>
        )}
      </div>
    </>
  );
}
